import { VariableRenderProps } from "../../../../../types/variable-render-props";

export function renderForSeasonal({ methods }: VariableRenderProps): boolean {
  if (methods) {
    const baseType = methods.watch("Type.Base");
    const currentType = methods.watch("Type.Current");
    return (
      baseType === "InputSeasonalWithSplits" ||
      baseType === "InputSeasonalNoSplits" ||
      ((currentType === "InputSeasonalWithSplits" ||
        currentType === "InputSeasonalNoSplits") &&
        !baseType)
    );
  }
  return true;
}
